import { BaseModel } from './base-model';
import { ProviderAdminObjectModel } from './provider-admin-object-model';

export class PageResultOffsetModel<A,B> extends BaseModel {
  items: A[];
  offset: number|null;
}
